// Mirrors FILTER_VARIANTS in the backend's custom-field query builder
export const FILTER_VARIANTS = {
  CONTAINS: "contains",
  EXACTLY_MATCHES: "exactly_matches",
  IS_EMPTY: "is_empty",
  IS_NOT_EMPTY: "is_not_empty",
} as const;
